import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import _ from "lodash";
import { convertSeatNumbersToSeats } from "./columnUtils";
import { ApiProvider } from "@src/store/ApiProvider";
import { AxiosError } from "axios";

export const getInventoryGroupKey = (item: Pick<EventInventoryRecord, "Listing_ID" | "Invoice_ID">): string =>
	item.Invoice_ID ? `Sold-${item.Listing_ID}-${item.Invoice_ID}` : `NotSold-${item.Listing_ID}`;

export const groupInventoryListings = (inventory: Array<EventInventoryRecord>): Array<EventInventoryRecord> =>
	_.map(
		_.groupBy(_.sortBy(inventory, "Listing_ID"), (x) => `${getInventoryGroupKey(x)}-${x.PO_ID}`),
		(value) => {
			const seatNumbers = value.map((x) => x.Seat_Number);
			return {
				...value[0],
				Seats: convertSeatNumbersToSeats(seatNumbers),
				Quantity: value.length,
				Item_Cost: value.reduce((acc, curr) => acc + curr.Item_Cost, 0),
			};
		},
	);

export const getNewInventoryListingIds = async ({
	CompanyName,
	EventId,
	allEventListingIds,
}: {
	CompanyName: string;
	EventId?: number;
	allEventListingIds: Array<number>;
}) => {
	try {
		if (!EventId) {
			return { data: null, error: "EventId doesn't exist" };
		}

		const updatedEventInventory = await ApiProvider.default.post<{ EventInventory: Array<EventInventoryRecord> }>(
			"/api/Pricing/QueryEventInventoryAll",
			{
				CompanyName,
				EventId,
				ForceRefresh: true,
			},
		);

		const updatedEventInventoryIds = Array.from(new Set(updatedEventInventory.EventInventory.map((x) => x.Listing_ID)));
		const newListingIds = updatedEventInventoryIds.filter((x) => !allEventListingIds.includes(x));

		if (!newListingIds.length) {
			return { data: null, error: "No new EventIds found" };
		}

		return { data: newListingIds, error: null };
	} catch (error) {
		let errorMessage = null;

		if (error instanceof AxiosError) errorMessage = error.message;
		else errorMessage = "Unknown error";
		return { data: null, error: errorMessage };
	}
};
